module.exports = __webpack_public_path__ + "static/media/pause.a5c9b385.svg";